export default __webpack_public_path__ + "images/close_x_object_1ad76bd2f8b71da94830436b0ac3c540.svg";